<template>
    <div>
        <div class="page-head">
            <a-icon @click="$router.go(-1)" type="left-square" theme="filled"/>
            <a-breadcrumb>
                <a-breadcrumb-item>首页</a-breadcrumb-item>
                <a-breadcrumb-item><a href="">客资管理</a></a-breadcrumb-item>
                <a-breadcrumb-item><router-link to="/clue">线索</router-link></a-breadcrumb-item>
                <a-breadcrumb-item><a href="">新建线索</a></a-breadcrumb-item>
            </a-breadcrumb>
        </div>

        <div class="add-clue">
            <div class="left-menu">
                <a href="javascript:;">
                    <span>基础信息</span>
                    <a-icon type="right" />
                </a>
            </div>
            <div class="right-content">
                <div class="top-title">
                    基础信息
                </div>
                <div class="add-content">
                    <a-form :label-col="{ span: 6 }" :wrapper-col="{ span: 18 }">
                        <a-input v-model="labelitem.addtype" hidden></a-input>
                        <a-form-item v-for="(item,i) in system_field_list" :key="i" :label="item.name"> 
                            <!-- {{item.field_name}} -->
                            <a-input v-model="labelitem[item.field_name]" v-if="item.type=='text'||item.type=='mobile'||item.type=='email'" placeholder="请输入"/>
                            <a-select v-if="item.type=='radio'"  @change="handleChange($event,item.field_name)"  placeholder="请选择" style="width: 100%">
                                <a-select-option :value="option" v-for="option in item.option_arr" :key="option">
                                    {{option}}
                                </a-select-option>
                            </a-select>

                            <a-select mode="multiple" v-if="item.type=='checkbox'"  @change="handleChange($event,item.field_name)"  placeholder="请选择" style="width: 100%">
                                <a-select-option :value="option" v-for="option in item.option_arr" :key="option">
                                    {{option}}
                                </a-select-option>
                            </a-select>

                            <a-date-picker format="YYYY-MM-DD" v-model="labelitem[item.field_name]"  v-if="item.type=='date'"/>
                            <a-textarea v-model="labelitem[item.field_name]" v-if="item.type=='textarea'" placeholder="请输入" :auto-size="{ minRows: 2,maxRows:6}"/>
                        </a-form-item>
    
                    </a-form>
                    
                </div>
               
            </div>
        </div>

        <div class="add-button">
            <a-button icon="close-circle" theme="filled" @click="quitadd">取消</a-button>
            <a-button icon="check-circle" type="primary" @click="saveclue" theme="filled">保存</a-button>
            <a-button icon="check-circle" type="primary" @click="savecluenewx" theme="filled">保存并创建下一条</a-button>
        </div>
    </div>

</template>

<script>
export default {
    data(){
        return{
            fieldlist:"",
            system_field_list:"",
            addresoptions:[],
            labelitem:{clue_name:"",clue_source:"",mobile_phone:"",telephone:"",
            wechat:"",qq:"",email:"",gender:"",birthday:"",company_name:"",address:"",
            website:"",industry_type:"",position:"",
enterprise_scale:"",remark:"",follow_status:"",cause_of_abandonment:""
            
            
            },
            labelname:[],
            test:""

        }
    },


    mounted(){
        // if(this.$route.query.phone){
        //     this.labelitem.mobile_phone=this.$route.query.phone
        // }
  
        


        
        
        // 字段
        this.$axios.get('/api/datafieldlist',{
            headers:{
                "appid": this.appSet.appid,
                "appkey": this.appSet.appkey,
                "token":localStorage.getItem('token'),
            },
            params:{
                is_edit:1
            }
        }).then((res)=>{
            if(res.data.code==200){

                var data=res.data.data.field_list
                var data2=res.data.data.system_field_list
                for(var i in data){
                    data2.push(data[i])
                }
                this.system_field_list=data2
                for(var j in data2){
                    this.labelname[data2[j].field_name]=""
                    this.labelitem[data2[j].field_name]=""
                }
                // alert(JSON.stringify(this.labelitem))
                    console.log(this.system_field_list)

                for(var i in this.system_field_list){
                    this.$set(this.labelitem,this.system_field_list[i].field_name,"")
                }
                 console.log(this.labelitem)
            }else{
                this.$message.warning(res.data.msg);
            }
        })
        if(this.$route.query.type==2){
            this.labelitem.addtype=2


        }else{
            this.labelitem.addtype=1
        }

       

        
    },
    methods:{
        quitadd(){
            this.$router.go(-1);
        },
        handleChange(event,value){
            this.labelitem[value]=event

        },
        // 保存
        saveclue(){
            // var addtype;
            // if(this.$route.query.type==2){
            //     addtype=2
            // }
            console.log(this.labelitem)
            this.$axios.post('/api/adddata',this.labelitem,{
                headers: {
                    "appid": this.appSet.appid,
                    "appkey": this.appSet.appkey,
                    "token":localStorage.getItem('token'),
                }
            }).then((res)=>{
                if(res.data.code==200){
                    this.$message.success(res.data.msg); 
                    var id=res.data.data.id
                    if(this.$route.query.type==2){
                        this.$router.push({path: '/cluedetail',query:{ id:id,type:1}});
                        // this.$router.push({path: '/clueseas'});
                    }else{
                        this.$router.push({path: '/cluedetail',query:{ id:id}});
                        // this.$router.push({path: '/clue'});
                    }
                }else{
                    this.$message.error(res.data.msg);
                }
            })
           
        },

        savecluenewx(){
             this.$axios.post('/api/adddata',this.labelitem,{
                headers: {
                    "appid": this.appSet.appid,
                    "appkey": this.appSet.appkey,
                    "token":localStorage.getItem('token'),
                }
            }).then((res)=>{
                if(res.data.code==200){
                    this.labelitem={}
                    this.$message.success(res.data.msg); 
                    this.$router.push({path: '/addclue'});
                }else{
                    this.$message.error(res.data.msg);
                }
            })
        },


        date(){

        },
        onPanelChange(value, mode) {

        }
    }
}
</script>




// WEBPACK FOOTER //
// src/components/customer/addclue.vue